export interface HeroContent {
  page: string;
  tagline?: string;
  title: string;
  subtitle?: string;
  description?: string;
  ctaText?: string;
  ctaLink?: string;
  backgroundImage: string;
  overlayGradient: string;
  navLabel?: string;
  seoTitle?: string;
}

export const heroContent: HeroContent[] = [
  {
    page: "inicio",
    tagline: "PROYECTO CICYT 2024",
    title: "Transferencia Brechas y Competencias",
    subtitle: "Capital Humano Médico en el Área de la Salud",
    description: "Proyecto que busca contribuir a una transferencia clara de los resultados, visibilizando el déficit de capital humano médico en la región de Tarapacá.",
    ctaText: "Conoce más",
    ctaLink: "#actualidad",
    backgroundImage: "https://storage.readdy-site.link/project_files/dd803486-334c-44db-be94-f45bc3cd2f43/9137c0ea-1f88-4dee-9235-551c3856966d_01.png?v=5bc43ae58177606abba3ce35eafa9ccc",
    overlayGradient: "bg-gradient-to-r from-primary-400/10 via-primary-400/5 to-secondary-500/10",
    navLabel: "Inicio",
    seoTitle: "Inicio | MásMed Tarapacá",
  },
  {
    page: "miradas",
    title: "Miradas",
    subtitle: "#VocesQueConstruyenSalud",
    description: "Distintas voces del territorio comparten su visión sobre los desafíos de la salud en Tarapacá.",
    ctaText: "Conoce más",
    backgroundImage: "https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/763796c63600d531925ec6ca3ade5c93.png",
    overlayGradient: "bg-gradient-to-r from-secondary-500/10 via-secondary-500/5 to-primary-400/10",
    navLabel: "Miradas",
    seoTitle: "Miradas | MásMed Tarapacá",
  },
  {
    page: "masmed",
    title: "MásMed Tarapacá",
    subtitle: "Más especialistas. Más salud. Mejor vida.",
    description: "Conoce el proyecto, su equipo y sus objetivos para mejorar el sistema de salud en la región.",
    ctaText: "Conoce el proyecto",
    backgroundImage: "https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/876d7401027a00f6c45a2a2c0d3e9570.png",
    overlayGradient: "bg-gradient-to-r from-primary-400/5 via-primary-400/0 to-primary-300/5",
    navLabel: "MásMed",
    seoTitle: "MásMed Tarapacá",
  },
  {
    page: "evidencias",
    title: "Evidencias",
    subtitle: "Información clave para comprender la realidad de la salud en Tarapacá y apoyar la toma de decisiones.",
    ctaText: "Ver informes",
    backgroundImage: "https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/848d7526b5813d585709a3f7e201d04c.jpeg",
    overlayGradient: "bg-gradient-to-r from-secondary-500/10 via-secondary-500/5 to-primary-400/10",
    navLabel: "Evidencias",
    seoTitle: "Evidencias | MásMed Tarapacá",
  },
  {
    page: "datos",
    title: "La Región",
    subtitle: "Visualización de datos relevantes del proyecto y del sistema de salud en la región.",
    ctaText: "Explorar territorio",
    backgroundImage: "https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/e2600a361401781bf7d22c591a6e4b76.png",
    overlayGradient: "bg-gradient-to-r from-primary-400/10 via-secondary-500/5 to-primary-500/10",
    navLabel: "La Región",
    seoTitle: "La Región | MásMed Tarapacá",
  },
  {
    page: "noticias",
    title: "Noticias",
    subtitle: "Conoce los avances, actividades y presencia de MásMed en la región.",
    ctaText: "Ver todas",
    backgroundImage: "https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/f1fa5cea46e5e0c59005193b165aea33.jpeg",
    overlayGradient: "bg-gradient-to-r from-primary-400/10 via-primary-400/5 to-primary-300/10",
    navLabel: "Noticias",
    seoTitle: "Noticias | MásMed Tarapacá",
  },
  {
    page: "contacto",
    title: "Contacto",
    subtitle: "Más especialistas. Más salud. Mejor vida.",
    backgroundImage: "https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/34e2b3c9c35cde83d278552f9e128ed7.png",
    overlayGradient: "bg-gradient-to-r from-secondary-500/10 via-secondary-500/5 to-primary-400/10",
    navLabel: "Contacto",
    seoTitle: "Contacto | MásMed Tarapacá",
  },
];